import DataTabs from "./PressureVesselData";
import EstimationTab from "../../AllEquipments/CommonFeatures/EstimationTab/index";
import CalculationTab from "./calculation_tabs";

// Estimation and Calculation data always saves/loads as part of the same
// Input Data revision (see PVContext.jsx), regardless of whether these
// tabs are shown.
export const pvTabs = (project) => {
  return [
    {
      label: "Input Data",
      panel: <DataTabs project={project} />,
    },
    {
      label: "Estimation",
      panel: <EstimationTab />,
    },
    {
      label: "Calculation",
      panel: <CalculationTab />,
    },
    // {
    //   label: "Modeling",
    //   panel: <ModelingPanel />,
    // },
    // {
    //   label: "Spec",
    //   panel: <SpecPanel />,
    // },
    // {
    //   label: "Tables",
    //   panel: <TablesPanel />,
    // },
  ];
};
